<template>
    <!-- bdsm结果页面 -->
    <div class="container">
        <!-- <div class="nav">
            <img src="../assets/img/08.png" class="img01" @click="back()" alt="">
            <div>BDSM情趣倾向测试</div>
        </div> -->
        <div class="bg">
            <div class="div1">
                <img src="../assets/img/15.png" class="img02" alt="">
                <img src="../assets/img/14.png" class="img03" alt="">

                <img src="../assets/img/17.png" class="img04" alt="">
            </div>
            <!-- 第一个统计图网 -->
            <div id="div2" ref="div2">
            </div>
            <!-- 圆环图 -->
            <div class="div3">
                <div>
                    <div class="circle" ref="circle1"></div>
                    <div class="text">Sado</div>
                </div>
                <div>
                    <div class="circle" ref="circle2"></div>
                    <div class="text">Dom</div>
                </div>
                <div>
                    <div class="circle" ref="circle3"></div>
                    <div class="text">Switch</div>
                </div>
                <div>
                    <div class="circle" ref="circle4"></div>
                    <div class="text">Maso</div>
                </div>
                <div>
                    <div class="circle" ref="circle5"></div>
                    <div class="text">Sub</div>
                </div>
                <div>
                    <div class="circle" ref="circle6"></div>
                    <div class="text">香草</div>
                </div>

            </div>
            <!-- 进度 -->
            <div class="div4">
                <div><img src="../assets/img/18.png" alt=""></div>
                <div class="pro"> <el-progress :percentage="dataRes.Experimentalist" color="#5F50FF" text-color="#000000"
                        class="pro1"></el-progress>
                    <div class="text">Experimentalist（实验者)</div>
                </div>
            </div>
            <div class="div4">
                <div><img src="../assets/img/19.png" alt=""></div>
                <div class="pro"> <el-progress :percentage="dataRes.Fantasists" color="#5F50FF" text-color="#000000"
                        class="pro1"></el-progress>
                    <div class="text">Fantasists（幻想者)</div>
                </div>
            </div>
            <img src="../assets/img/16.png" class="img05" alt="">
            <!-- 第二个统计图网 -->
            <div id="div5" ref="div5"></div>
            <!-- 第三个个统计图网 -->
            <div id="div6" ref="div6"></div>
            <!-- 列表展示 -->
            <div class="div7">
                <div class="div7-1"> <img src="../assets/img/20.png" class="img05" alt="">
                    <div>
                        <span class="title">束缚者</span><span class="num">{{ dataRes.Restrainer }}</span>
                    </div>
                    <div>
                        <span class="title">萨德者</span><span class="num">{{ dataRes.Sadist }}</span>
                    </div>
                    <div>
                        <span class="title">支配者</span><span class="num">{{ dataRes.Dominant }}</span>
                    </div>
                    <div>
                        <span class="title">贬低者</span><span class="num">{{ dataRes.Degrader }}</span>
                    </div>
                    <div>
                        <span class="title">照料者</span><span class="num">{{ dataRes.Caregiver }}</span>
                    </div>
                    <div>
                        <span class="title">宠物所有者</span><span class="num">{{ dataRes.Pet_Owner }}</span>
                    </div>
                    <div>
                        <span class="title">主人 </span><span class="num">{{ dataRes.Master }}</span>
                    </div>
                    <div>
                        <span class="title">原始猎手 </span><span class="num">{{ dataRes.Primal_Hunter }}</span>
                    </div>
                </div>
                <div class="div7-2"> <img src="../assets/img/25.png" alt=""></div>
                <div class="div7-1"><img src="../assets/img/21.png" class="img05" alt="">
                    <div>
                        <span class="title">捣蛋鬼 </span><span class="num">{{ dataRes.Brat }}</span>
                    </div>
                    <div>
                        <span class="title">受束者 </span><span class="num">{{ dataRes.Restrainee }}</span>
                    </div>
                    <div>
                        <span class="title">马索克 </span><span class="num">{{ dataRes.Masochist }}</span>
                    </div>
                    <div>
                        <span class="title">顺从者 </span><span class="num">{{ dataRes.Submissive }}</span>
                    </div>
                    <div>
                        <span class="title">降格者 </span><span class="num">{{ dataRes.Degradee }}</span>
                    </div>
                    <div>
                        <span class="title">被照料者 </span><span class="num">{{ dataRes.Little }}</span>
                    </div>
                    <div>
                        <span class="title">仆人   </span><span class="num">{{ dataRes.Slave }}</span>
                    </div>
                    <div>
                        <span class="title">原始猎物 </span><span class="num">{{ dataRes.Prey }}</span>
                    </div>
                </div>
            </div>
            <!-- 二维码 -->
            <img src="../assets/img/29.png" class="img29"  alt="">
        </div>
    </div>
</template>

<script>
import { getAnswer } from "@/api/api.js";
import * as echarts from 'echarts';
export default {
    name: 'HelloWorld',
    data() {
        return {
            answerArr: [],//问题
            index: 0,
            dataRes: {},
            chartColumn1: null,
            chartColumn2: null,
            chartColumn3: null,
            circle1: null,
            circle2: null,
            circle3: null,
            circle4: null,
            circle5: null,
            circle6: null,
            // 圆环图
            option1: {
                title: {

                    textStyle: {
                        fontSize: "16px",
                        color: "#217B99"
                    },
                    left: 'center',
                    top: 'center'
                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center',
                        },


                        color: [
                            '#B2DAE7',
                            '#F7F6F2'
                        ],
                        radius: ['60%', '70%']
                    }
                ]
            },
            option2: {
                title: {
                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: "16px",
                        color: "#27C69D"
                    },
                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center'
                        },
                        color: [
                            ' #98F3D6',
                            '#F7F6F2'
                        ],

                        radius: ['60%', '70%']
                    }
                ]
            },
            option3: {
                title: {

                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: "16px",
                        color: "#D34773"
                    },
                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center'
                        },
                        color: [
                            '#E9A3B9',
                            '#F7F6F2'
                        ],
                        radius: ['60%', '70%']
                    }
                ]
            },
            option4: {
                title: {

                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: "16px",
                        color: "#87AE43"
                    },

                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center'
                        },
                        color: [
                            '#C5E89B',
                            '#F7F6F2'
                        ],
                        radius: ['60%', '70%']
                    }
                ]
            },
            option5: {
                title: {

                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: "16px",
                        color: "#B24E32"
                    },

                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center'
                        },

                        color: [
                            '#F8C2B2',
                            '#F7F6F2'
                        ],
                        radius: ['60%', '70%']
                    }
                ]
            },
            option6: {
                title: {

                    textStyle: {
                        fontSize: "16px",
                        color: "#586F6C"
                    },
                    left: 'center',
                    top: 'center'
                },
                series: [
                    {
                        type: 'pie',
                        label: {
                            show: false,
                            position: 'center'
                        },

                        color: [
                            '#98A1A0',
                            '#F7F6F2'
                        ],
                        radius: ['60%', '70%']
                    }
                ]
            },
            // 镭射图
            option: {

                radar: {
                    indicator: [
                        { name: 'Sado', max: 100, color: '#000' },
                        { name: 'Dom', max: 100, color: '#000' },
                        { name: 'Switch', max: 100, color: '#000' },
                        { name: 'Maso', max: 100, color: '#000' },
                        { name: 'Sub', max: 100, color: '#000' }
                    ]
                },

                series: [
                    {
                        name: 'Budget vs spending',
                        type: 'radar',
                        itemStyle: {
                            color: 'rgba(163, 254, 232, 1)'
                        },
                        areaStyle: {
                            opacity: 0.1
                        },

                        data: [
                            // {
                            //     value: [74, 72, 70, 65, 55],
                            //     color: "rgba(44, 247, 198, 0.1)"
                            // },
                            {
                                value: [],

                            }
                        ]
                    }
                ]
            },
            // 镭射图
            option7: {

                radar: {
                    indicator: [
                        { name: '束缚者', max: 100, color: '#000' },
                        { name: '训练师 ', max: 100, color: '#000' },
                        { name: '主人', max: 100, color: '#000' },
                        { name: '所有者', max: 100, color: '#000' },
                        { name: '照料者 ', max: 100, color: '#000' },
                        { name: '贬低者 ', max: 100, color: '#000' },
                        { name: '支配者 ', max: 100, color: '#000' },
                        { name: ' 萨德 ', max: 100, color: '#000' },

                    ]
                },

                series: [
                    {

                        type: 'radar',
                        itemStyle: {
                            color: 'rgba(163, 254, 212, 1)'
                        },
                        areaStyle: {
                            opacity: 0.1
                        },

                        data: [
                            // {
                            //     value: [74, 72, 70, 65, 55],
                            //     color: "rgba(44, 247, 198, 0.1)"
                            // },
                            {
                                value: [],

                            }
                        ]
                    }
                ]
            },
            // 镭射图
            option8: {

                radar: {
                    indicator: [
                        { name: '受束者', max: 100, color: '#000' },
                        { name: '捣蛋鬼', max: 100, color: '#000' },
                        { name: '仆人', max: 100, color: '#000' },
                        { name: '宠物', max: 100, color: '#000' },
                        { name: '被照料者', max: 100, color: '#000' },
                        { name: '降格者', max: 100, color: '#000' },
                        { name: '顺从者', max: 100, color: '#000' },
                        { name: '马索克', max: 100, color: '#000' },

                    ]
                },

                series: [
                    {

                        type: 'radar',
                        itemStyle: {
                            color: 'rgba(115, 112, 254, 1)'
                        },
                        areaStyle: {
                            opacity: 0.1
                        },

                        data: [
                            // {
                            //     value: [74, 72, 70, 65, 55],
                            //     color: "rgba(44, 247, 198, 0.1)"
                            // },
                            {
                                value: [],

                            }
                        ]
                    }
                ]
            }
        }
    },
    mounted() {
        this.submit()
    },
    methods: {
        initChart() {

        },
        back() {
            this.$router.go(-1)
        },

        submit() {
          let data = {
            act: "result",
            uid: this.$route.query.uid || 0,
            token: this.$route.query.token || 0,
            env: this.$route.query.env || 0,
            result: this.$route.params.resultArr
          }
            // let data = {
            //     act: "result", result:
            //         [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 3, 3, 3, 3, 3, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3]
            // }
            getAnswer(data).then((res) => {
                this.dataRes = res.data;
                
                this.chartColumn1 = echarts.init(this.$refs.div2);
                this.option.series[0].data[0].value = [res.data.Sado, res.data.Dom, res.data.Switch, res.data.Maso, res.data.Sub];
                this.chartColumn1.setOption(this.option);

                this.circle1 = echarts.init(this.$refs.circle1);
                this.option1.title.text = res.data.Sado + '%';
                this.option1.series[0].data = [{ value: res.data.Sado }, { value: 100 - res.data.Sado }]
                this.circle1.setOption(this.option1);

                this.circle2 = echarts.init(this.$refs.circle2);
                this.option2.title.text = res.data.Dom + '%';
                this.option2.series[0].data = [{ value: res.data.Dom }, { value: 100 - res.data.Dom }]
                this.circle2.setOption(this.option2);

                this.circle3 = echarts.init(this.$refs.circle3);
                this.option3.title.text = res.data.Switch + '%';
                this.option3.series[0].data = [{ value: res.data.Switch }, { value: 100 - res.data.Switch }]
                this.circle3.setOption(this.option3);

                this.circle4 = echarts.init(this.$refs.circle4);
                this.option4.title.text = res.data.Maso + '%';
                this.option4.series[0].data = [{ value: res.data.Maso }, { value: 100 - res.data.Maso }]
                this.circle4.setOption(this.option4);

                this.circle5 = echarts.init(this.$refs.circle5);
                this.option5.title.text = res.data.Sub + '%';
                this.option5.series[0].data = [{ value: res.data.Sub}, { value: 100 - res.data.Sub }]
                this.circle5.setOption(this.option5);

                //香草=100%-Switch数值
                let vanilla=(100-res.data.Switch).toFixed(2);
                console.log(vanilla);
                this.circle6 = echarts.init(this.$refs.circle6);
                this.option6.title.text = vanilla + '%';
                this.option6.series[0].data = [{ value: vanilla }, { value: 100 - vanilla }]
                this.circle6.setOption(this.option6);

                this.chartColumn2 = echarts.init(this.$refs.div5);
                //  束缚者   训练师  主人   所有者   照料者   贬低者  支配者   萨德   
                this.option7.series[0].data[0].value = [res.data.Restrainer, res.data.Brat_Tamer, res.data.Master, res.data.Pet_Owner, res.data.Caregiver, res.data.Degrader, res.data.Dominant, res.data.Sadist];
                this.chartColumn2.setOption(this.option7);


                this.chartColumn3 = echarts.init(this.$refs.div6);
                //  受束者  捣蛋鬼  仆人  宠物  被照料者   降格者  顺从者   马索克   受束者 
                this.option8.series[0].data[0].value = [res.data.Restrainee, res.data.Brat, res.data.Slave, res.data.Prey, res.data.Little, res.data.Degradee, res.data.Submissive, res.data.Masochist, res.data.Restrainee];
                this.chartColumn3.setOption(this.option8);
                console.log(55)





            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Group 2070 */
.img29{
    width: 3.38rem;
    margin: 0.3rem auto;
}
.div7 {
    display: flex;
    justify-content: space-around;
    margin-top: 0.6rem;

}

.div7-1 {
    width: 1.5rem;
    position: relative;
    margin: 0px auto;
}

.div7-1>div,
.div7-3>div {
    height: 0.4rem;
    line-height: 0.4rem;
    display: flex;
    justify-content: space-evenly;


}

.div7-1 img,
.div7-3 img {
    width: 0.92rem;
    margin: 0px auto 0.2rem;
}

.div7-1 span {
    font-size: 14px;
}

.div7 .title {
    color: rgba(51, 51, 51, 1);
    position: absolute;
    left: 0px;

}

.div7 .num {
    color: rgba(102, 102, 102, 1);
    position: absolute;
    right: 0px;

}

.div7-2 img {
    width: 1px;
    margin-top: 0.45rem;
}

.img05 {
    width: 1.15rem;
    margin-left: 0.15rem;
    margin-top: 0.6rem;

}

/* 进度条 */
.div4 {
    width: 3.3rem;
    height: 0.49rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.1px auto 0.2rem;
}

.div4 .text {
    font-size: 16px;
    font-weight: 600;
}

.div4 img {
    width: 0.23rem;
    margin-right: 0.1rem;
}

.div4 .pro {
    width: 2.8rem;
    height: 0.49rem;


}

.div4 .pro .pro1 {
    width: 2.8rem;
    height: 0.49rem;
    line-height: 0.35rem;
}

/* 圆环 */
.div3 {
    display: flex;
    flex-wrap: wrap;
    margin: 0px auto 0.3rem;
    justify-content: center;
}

.div3 .circle {
    width: 1rem;
    height: 1rem;
    padding: 0rem 0.1rem;
    display: flex;
    justify-content: center;

}

.div3 .text {
    font-size: 14px;
    text-align: center;
    font-weight: 600;
}

/*  */
#div2,
#div5,
#div6 {
    width: 3.2rem;
    height: 2.7rem;
    margin: 0.1rem auto 0rem;
    position: relative;
    display: flex;
    justify-content: center;
}

#div5,
#div6 {
    margin-top: 0.4rem;
}

#div2>div,
#div5>div,
#div6>div {
    margin: 0px auto;
}

.div1 {
    position: relative;
}

.div1 .img04 {
    position: absolute;
    right: 0px;
    top: -0.3rem;
}

.div1 .img03 {
    width: 1.56rem;
    margin-top: 0.32rem;
    margin-left: 0.15rem;
}

.div1 .img02 {
    width: 2.15rem;
    margin-top: 0.27rem;
    margin-left: 0.15rem;
}

/* 导航 */
.nav {
    height: 0.44rem;
    display: flex;
    align-items: center;
}

.nav div {
    width: 100%;
    font-size: 22px;
    text-align: center;
    position: relative;
    line-height: 0.44rem;
    text-align: center;
}

.img01 {
    width: 0.22rem;
    position: absolute;
    left: 0.15rem;
    z-index: 3;
}
</style>